// This file was auto-generated by __GENERATE_CHAIN_PRESETS__.js. Do not edit manually.

import { redstone as _redstone } from 'viem/chains'
import { createCommon } from '../createCommon.js'

/**
 * Creates a common configuration for the redstone chain.
 * @type {import('../Common.js').Common}
 * @description
 * Chain ID: 690
 * Chain Name: Redstone
 * Default Block Explorer: 	https://explorer.redstone.xyz
 * Default RPC URL: https://rpc.redstonechain.com
 * @example
 * import { createMemoryClient } from 'tevm'
 * import { redstone } from 'tevm/common'
 * import { http } from 'tevm'
 *
 * const client = createMemoryClient({
 *   common: redstone,
 *   fork: {
 *     transport: http({ url: 'https://example.com' })({})
 *   },
 * })
 */
export const redstone = createCommon({
	..._redstone,
	loggingLevel: 'warn',
	eips: [],
	hardfork: 'prague',
})
